<template>
	<Col class="width-100 height-100 flex-centerize">
		<h5 class="description-text mb-5">Hover over the notification to see call to action and links</h5>
		<BuilderNotification :icon="icon" :title="title" :additionalInfo="additionalInfo" :takeActionTitle="takeActionTitle" />
	</Col>
</template>

<script>
import BuilderNotification from '@/components/BlockEditorNotification/PreviewTabs/BuilderNotification.vue';
export default {
	name: 'PlyInboxNotificationTab',
	props: {
		icon: { type: String },
		title: { type: String },
		additionalInfo: { type: String },
		takeActionTitle: { type: String },
	},
	components: { BuilderNotification },
};
</script>

<style scoped lang="scss">
.description-text {
	color: #b3b3b3;
}
</style>
